// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-module--navigation--37byk","navigationIcon":"navigation-module--navigationIcon--UamId","navigationLogo":"navigation-module--navigationLogo--1XWph"};